export default __webpack_public_path__ + "static/media/naamta.8db28074.png";